import * as types from '../actions/types'
import { validateTextInput, validateAllFields } from '../utils/validation'

const initAddress = {
  id: '',
  firstName: '',
  lastName: '',
  street: '',
  landmark: '',
  city: '',
  state: '',
  country: '',
  postCode: '',
  postBox: '',
  phone: '',
  district: '',
}
const ininitalState = {
  isLaoding: false,
  list: [],
  mode: 'list',
  allCountries: [],
  states: [],
  selectedAddress: initAddress,
  showAddressFeedback: false,
  showDeleteAddressModal: false,
  countryCode: '',
  merchantCountry: '',
  errors: {},
  isFormValid: false,
  delete: {
    error: false,
    message: '',
  },
  add: {
    error: false,
    message: '',
  },
}

const AddressReducer = (state = ininitalState, action) => {
  switch (action.type) {
    case types.UPDATE_ADDRESS:
      return {
        ...state,
        list: action.payload,
      }
    case types.EDIT_MODE:
      return {
        ...state,
        mode: 'edit',
      }
    case types.LIST_MODE:
      return {
        ...state,
        mode: 'list',
      }
    case types.NEW_MODE:
      return {
        ...state,
        mode: 'new',
      }
    case types.UPDATE_ALL_COUNTRIES:
      return {
        ...state,
        allCountries: action.payload,
      }
    case types.UPDATE_STATES:
      return {
        ...state,
        states: action.payload,
      }
    case types.TOGGLE_LOADER:
      return {
        ...state,
        isLaoding: action.payload,
      }
    case types.SET_INITIAL_SELECTED_ADDRESS_ID:
      return {
        ...state,
        selectedAddress: {
          ...state.selectedAddress,
          id: action.payload,
        },
      }
    case types.SET_SELECTED_ADDRESS_ID: {
      let updatedAddress = state.selectedAddress
      let { countryCode } = state
      const { allCountries } = state
      if (state.list.length > 0) {
        const selectedAddress = state.list.find(
          (address) => address.id === action.payload,
        )
        updatedAddress = {
          firstName: selectedAddress.first_name ? selectedAddress.first_name : '',
          lastName: selectedAddress.last_name ? selectedAddress.last_name : '',
          phone: selectedAddress.phone ? selectedAddress.phone : '',
          street: selectedAddress.address_hash.street_address ? selectedAddress.address_hash.street_address : '',
          landmark: selectedAddress.address_hash.landmark ? selectedAddress.address_hash.landmark : '',
          city: selectedAddress.address_hash.city ? selectedAddress.address_hash.city : '',
          state: selectedAddress.address_hash.state ? selectedAddress.address_hash.state : '',
          country: selectedAddress.address_hash.country ? selectedAddress.address_hash.country : '',
          postCode: selectedAddress.address_hash.postcode ? selectedAddress.address_hash.postcode : '',
          postBox: selectedAddress.address_hash.poboxnumber ? selectedAddress.address_hash.poboxnumber : '',
          district: selectedAddress.address_hash.district ? selectedAddress.address_hash.district : '',
        }
        const countryCodeFinder = allCountries.find(
          (c) => (c.code === selectedAddress.address_hash.country),
        )
        countryCode = countryCodeFinder.phone_code
      }
      return {
        ...state,
        selectedAddress: {
          ...state.selectedAddress,
          ...updatedAddress,
          id: action.payload,
        },
        countryCode,
      }
    }
    case types.RESET_ADDRESS: {
      return {
        ...state,
        selectedAddress: initAddress,
      }
    }
    case types.ON_TEXT_FIELD_CHANGE: {
      const { target } = action.payload
      const errors = validateTextInput(state, target.id, target.value)

      return {
        ...state,
        selectedAddress: {
          ...state.selectedAddress,
          [target.id]: target.value,
        },
        errors: {
          ...state.errors,
          ...errors,
        },
      }
    }
    case types.ON_SELECT_CHANGE: {
      const { value, field } = action.payload
      const errors = validateTextInput(state, field, value)

      return {
        ...state,
        selectedAddress: {
          ...state.selectedAddress,
          [field]: value,
        },
        errors: {
          ...state.errors,
          ...errors,
        },
      }
    }
    case types.VALIDATE_ALL_FIELDS: {
      const fieldErrors = validateAllFields(state)
      const isFormValid = !(Object.keys(fieldErrors).filter((el) => !!fieldErrors[el]).length)

      return {
        ...state,
        errors: {
          ...fieldErrors,
        },
        isFormValid,
      }
    }
    case types.CLEAR_VALIDATION_ERROR_MESSAGES: {
      return {
        ...state,
        isFormValid: false,
        errors: {},
      }
    }
    case types.SET_MERCHANT_COUNTRY: {
      return {
        ...state,
        selectedAddress: {
          ...state.selectedAddress,
          country: action.payload,
        },
      }
    }
    case types.UPDATE_COUNTRY_CODE: {
      return {
        ...state,
        countryCode: action.payload,
      }
    }
    case types.RESET_STATES: {
      return {
        ...state,
        selectedAddress: {
          ...state.selectedAddress,
          state: '',
        },
      }
    }
    case types.HIDE_ADDRESS_FEEDBACK: {
      return {
        ...state,
        showAddressFeedback: false,
      }
    }
    case types.SHOW_ADDRESS_FEEDBACK: {
      return {
        ...state,
        showAddressFeedback: true,
      }
    }
    case types.SHOW_DELETE_ADDRESS_MODAL: {
      return {
        ...state,
        showDeleteAddressModal: true,
      }
    }
    case types.HIDE_DELETE_ADDRESS_MODAL: {
      return {
        ...state,
        showDeleteAddressModal: false,
      }
    }
    case types.SHOW_DELETE_ADDRESS_ERROR: {
      return {
        ...state,
        delete: {
          error: true,
          message: action.payload,
        },
      }
    }
    case types.CLEAR_DELETE_ADDRESS_ERROR: {
      return {
        ...state,
        delete: {
          error: false,
          message: '',
        },
      }
    }
    case types.SHOW_ADD_ADDRESS_ERROR: {
      return {
        ...state,
        add: {
          error: true,
          message: action.payload,
        },
      }
    }
    case types.CLEAR_ADD_ADDRESS_ERROR: {
      return {
        ...state,
        add: {
          error: false,
          message: '',
        },
      }
    }
    default:
      return state
  }
}

export default AddressReducer
